import React, {memo, ReactNode, useLayoutEffect, useRef, useState} from 'react';
import {Bubble, BubbleProps} from 'tea-component';
import ResizeObserver from 'resize-observer-polyfill';
import './index.scss';

interface Props extends BubbleProps{
  content: ReactNode; // 浮窗内容
  ellipsisContent?: ReactNode; // 省略号的内容 (为了兼容浮窗内容和普通内容有不同展示的需求)
  ellipsisClassName?: string; // 省略号的内容的className
}

const BubbleEllipsis = (props: Props) => {
  const { content, ellipsisContent=content, ellipsisClassName='', ...resetProps } = props;
  /**
   * 如果 内容不存在 或者 为 - , 那么就不需要 各种hook和Bubble了
   */
  if (!ellipsisContent || ellipsisContent === '-') {
    return (<>{ellipsisContent}</>);
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const ref = useRef<HTMLDivElement | null>(null);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [visible, setVisible] = useState(false);

  // 情况一: 元素宽度变化, 导致省略号显示或隐藏
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useLayoutEffect(() => {
    const resizeObserver = new (window.ResizeObserver || ResizeObserver)(() => {
      if (ref.current) {
        setVisible(ref.current.offsetWidth < ref.current.scrollWidth);
      }
    });

    ref.current && resizeObserver.observe(ref.current as HTMLDivElement);
    return () => {
      resizeObserver.disconnect();
    };
  }, []);
  
  // 情况二: 元素内容变化, 导致省略号显示或隐藏
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useLayoutEffect(() => {
    if (ref.current) {
      setVisible(ref.current.offsetWidth < ref.current.scrollWidth);
    }
  }, [ellipsisContent]);
  
  return (<Bubble
    arrowPointAtCenter
    placement="top"
    dark
    {...resetProps}
    content={visible ? content : undefined}
  >
    <div ref={ref} className={`${ellipsisClassName} dbl-bubble-ellipsis`}>
      {ellipsisContent}
    </div>
  </Bubble>);
 
};

export default memo(BubbleEllipsis);